import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../../stores/hooks";

import * as S from "./style";
import { t } from "i18next";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { Colors } from "@smartsuite/types";
import { capitalizeFirstLetter } from "../../../../../utils/strings";

export const LimitsDisclamer90 = observer(() => {
  const { limits } = useRootStore();
  const key = limits.canPlanBeUpgraded()
    ? "limits.xx-disclamer-text-upgrade"
    : "limits.xx-disclamer-text";

  return (
    <S.Wrapper>
      <S.IconWrapper>
        <Icon name="important-lined" color={Colors.bYellow} />
      </S.IconWrapper>

      <S.Disclamer>
        <S.Title>
          <Text weight="medium">{t("attention")}</Text>
        </S.Title>
        <S.Message>
          <Text>
            {t(key, {
              usagePercentage:
                ((100 * limits.limits.usage) / limits.limits.limit) | 0,
              limit: limits.limits.limit,
              planCategory: capitalizeFirstLetter(limits.limits.planCategory),
            })}
            {"  "}
            <S.Link>
              <a
                href="https://help.smartsuite.com/en/articles/4759982-automation-limits"
                target="_blank"
                className="link"
                rel="noopener"
              >
                {t("learn-more2")}
              </a>
            </S.Link>
          </Text>
        </S.Message>
      </S.Disclamer>
    </S.Wrapper>
  );
});
